import React, {useMemo} from "react";
import {generateBreadcrumbs} from "@widgets/layout/Breadcrumbs";
import {PageHeading} from "peggirkit";
import {useIntl} from "react-intl";
import router, {Route} from "@/routing/Router";
import SynchronizationOverviewHeadingActions from "./SynchronizationOverviewHeadingActions";
import SynchronizationOverviewHeadingMeta
    from "@widgets/synchronization/overview/heading/pageHeading/SynchronizationOverviewHeadingMeta";
import {SetStateFn} from "@/utils/SetStateUtils";
import {RestaurantSyncStatus} from "@/data/entities/sync";

type Props = {
    restaurantSyncStatus: RestaurantSyncStatus | null,
    loadingUpdatingStatus: boolean,
    setLoadingUpdatingStatus: SetStateFn<boolean>,
    setShowSynchronizeMenuModal: SetStateFn<boolean>,
};

const SynchronizationOverviewHeading = ({
                                            restaurantSyncStatus,
                                            loadingUpdatingStatus,
                                            setLoadingUpdatingStatus,
                                            setShowSynchronizeMenuModal,
                                        }: Props) => {
    const intl = useIntl();
    const route: Route = useMemo(() => router.synchronization, []);

    return (
        <PageHeading
            breadcrumbs={generateBreadcrumbs(route, intl)}
            title={route.name(intl)}
            actionRow={
                <SynchronizationOverviewHeadingActions
                    loadingUpdatingStatus={loadingUpdatingStatus}
                    setLoadingUpdatingStatus={setLoadingUpdatingStatus}
                    setShowSynchronizeMenuModal={setShowSynchronizeMenuModal}
                />
            }
            meta={
                <SynchronizationOverviewHeadingMeta
                    restaurantSyncStatus={restaurantSyncStatus}
                />
            }
            actionRowHorizontal={false}
            breakpoints={{"2xl": {actionRowHorizontal: true}}}
        />
    );
};

export default SynchronizationOverviewHeading;